var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailDeprecatedFilterIcon = function SvgEmailDeprecatedFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3264_489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.551 19.561C17.088 19.883 16.587 20.165 16.045 20.389C15.04 20.806 13.999 21 12.974 21C8.843 21 5.444 17.879 5 13.866",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.541 12.974V14.312C16.541 15.544 17.539 16.541 18.77 16.541C20.002 16.541 20.999 15.543 20.999 14.312V12.974C20.999 8.843 17.878 5.444 13.865 5",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11.5C4.127 11.5 2 9.373 2 6.75C2 4.127 4.127 2 6.75 2C9.373 2 11.5 4.127 11.5 6.75C11.5 9.373 9.373 11.5 6.75 11.5Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.40991 5.40997L8.08991 8.08997",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.40991 8.08997L8.08991 5.40997",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53296 13.866C9.93096 15.402 11.314 16.541 12.974 16.541C14.944 16.541 16.541 14.944 16.541 12.974C16.541 11.314 15.401 9.93102 13.866 9.53302",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3264_489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgEmailDeprecatedFilterIcon as ReactComponent };
export default __webpack_public_path__ + "email-deprecated-filter-icon.svg";